const AREAS = [
  { name: 'Приютово', note: 'производство' },
  { name: 'Белебей', note: '' },
  { name: 'Ермекеево', note: '' },
  { name: 'Бижбуляк', note: '' },
  { name: 'Абдулино', note: '' },
  { name: 'Пономарёвка', note: '' },
  { name: 'Матвеевка', note: '' },
  { name: 'Новомихайловка', note: '' },
  { name: 'Бавлы', note: '' },
  { name: 'Бугуруслан', note: '' },
  { name: 'Киргиз-Мияки', note: '' },
  { name: 'Туймазы', note: '' },
  { name: 'Октябрьский', note: '' },
  { name: 'Буздяк', note: '' },
  { name: 'Кандры', note: '' },
  { name: 'Давлеканово', note: '' },
  { name: 'Раевка', note: '' },
  { name: 'Уфа', note: '' },
  { name: 'Чишмы', note: '' },
];

export default function ServiceAreas() {
  return (
    <section className="py-16 md:py-20 bg-background-50" id="areas">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1000px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Выезд на замер
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Приезжаем на&nbsp;ваш участок, делаем точные замеры, оцениваем условия и&nbsp;даём рекомендации. Замер бесплатный при&nbsp;последующем заказе.
          </p>
        </div>

        <div className="bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-8 mb-8">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="font-heading text-lg font-semibold text-foreground-950">
              Выезжаем в следующие населённые пункты:
            </h3>
          </div>
          <p className="text-sm text-foreground-500 mb-6">
            Производство находится в&nbsp;<strong className="text-foreground-800">Приютово</strong>
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
            {AREAS.map((area) => (
              <div
                key={area.name}
                className="flex items-center gap-3 bg-background-50 border border-background-200/50 rounded-md px-4 py-3"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 shrink-0">
                  <i className="ri-map-pin-line"></i>
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-950">{area.name}</p>
                  {area.note && (
                    <p className="text-xs text-foreground-400">{area.note}</p>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Map */}
          <div className="rounded-md overflow-hidden border border-background-200/50">
            <iframe
              src="https://yandex.ru/map-widget/v1/?um=constructor%3A4b4047794a553f387b49e94f467c6a253e587efb125a38a496e1dd2a068eaf47&amp;source=constructor"
              width="476"
              height="409"
              frameBorder="0"
              className="w-full"
            ></iframe>
          </div>
          <p className="text-xs text-foreground-400 mt-3 text-center">
            Зона обслуживания — до 300 км от Приютово
          </p>
        </div>

        <div className="text-center">
          <p className="text-sm text-foreground-600 mb-6">
            Работаете в другом городе? Позвоните — обсудим возможность выезда. При&nbsp;большом объёме заказа можем приехать и&nbsp;дальше.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="tel:+79174131562"
              className="whitespace-nowrap w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 cursor-pointer text-center"
            >
              Позвонить
            </a>
            <a
              href="#cta-form"
              className="whitespace-nowrap w-full sm:w-auto border-2 border-foreground-200 hover:border-primary-400 text-foreground-800 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 cursor-pointer text-center"
            >
              Оставить заявку
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}